<template>
  <div class="wrapper">
    <div>
    <CButton  color="info" @click="openModal"><b>Add New Keperluan</b></CButton>
    <CRow class="mt-3">
      <div>  
      </div>
      <CCol sm="12">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <Datatable 
                            :items="items" 
                            :fields="fields" 
                            :meta="meta" 
                            @per_page="handlePerPage" 
                            @pagination="handlePagination" 
                            @search="handleSearch" 
                            @sort="handleSort"
                            @is_active="handleIsActive"
                            :btn_show="false"
                            :btn_edit="true"
                            :btn_deactivate="true"
                            :btn_reactivate="true"
                            :btn_delete="false"
                            @show="handleShow"
                            @edit="handleEdit"
                            @deactivate="handleDeactivate"
                            @reactivate="handleReactivate"

                        />
                    </div>
                </div>
            </div>
        </div>
      </CCol>
    </CRow>
      <keperluanmodal></keperluanmodal>
      <alertmodal></alertmodal>
    </div>
  </div>
</template>

<script>
import Datatable from '@/components/datatables.vue'
import axios from 'axios'
import keperluan from '@/services/keperluan'
import keperluanmodal from './keperluanmodal';
import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';
import store from '@/store.js'

const token = localStorage.getItem('token');

export default {
  name: 'KeperluanTables',
  components: { keperluanmodal, alertmodal, Datatable },
  data(){
    return{
      form:{
        name:'',
      },
      updateSubmit: false,
      largeModal:false,
    
      //fungsi yang harus digunakan
      //start
      fields: [
          {key: 'name', sortable: false, },
          {key: 'is_active', sortable: false, },
          {key: 'action', label: 'Action', sortable: false},
      ],
      items: [],
      meta: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      is_active: 1,
      //end
    }
    //end
  },

  created() {
      //this.loadData()
  },
  mounted (){
     this.loadData()

    EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });

   },
   
  methods: {
    openModal: function () {
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit tujuan') !== -1){
          //IF ALLOW
      var params = {title: 'Add New Keperluan', mode:'create'}
      EventBus.$emit('OPEN_MODAL_KEPERLUAN', params)
       //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
    },


    openModalEdit(id){
       let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit tujuan') !== -1){
          //IF ALLOW
        var params = {title: 'Edit Keperluan', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_KEPERLUAN', params)
         //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
    },

    deactivate(id){
       //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Delete tujuan') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to deactivate?")){
        keperluan.deactivateKeperluan(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
      //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },

    reactivate(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Delete tujuan') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to reactivate?")){
        keperluan.reactivateKeperluan(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
      //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },

    loadData() {
      let current_page = this.search == '' ? this.current_page:1
      var params = {
       
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
      }


      keperluan.getKeperluanDataSource(params)
      .then(res => {
          let getData = res.data
          this.items = getData.data
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },

    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleShow(val) {
        this.openShow(val) 
    }, 
    handleEdit(val) {
        this.openModalEdit(val) 
    },    
    handleDeactivate(val) {
        this.deactivate(val)       
    },
    handleReactivate(val) {
        this.reactivate(val)       
    },

  }
}
</script>